module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/martech_bg_2-72bb5f017d20854083a4c8ca3150476b.png";